import _set from 'lodash/set';
import moment from 'moment-timezone';

const calendar = {
  /* SET */
  setStartDate(state, startDate) {
    state.startDate = moment(startDate);
  },
  setEndDate(state, endDate) {
    state.endDate = moment(endDate);
  },

  /* INCREMENT & DECREMENT */
  changeMonth(state, date) {
    state.endDate = moment(date).add(1, 'months');
    state.startDate = moment(date);
  },
  incrementStartDate(state) {
    state.startDate = moment(state.startDate).clone().add(1, 'months');
  },
  incrementEndDate(state) {
    state.endDate = moment(state.endDate).clone().add(1, 'months');
  },
  decrementStartDate(state) {
    state.startDate = moment(state.startDate).clone().subtract(1, 'months');
  },
  decrementEndDate(state) {
    state.endDate = moment(state.endDate).clone().subtract(1, 'months');
  },

  /* RESET */
  resetStartDate(state) {
    state.startDate = moment();
  },
  resetEndDate(state) {
    state.endDate = moment().add(1, 'months');
  },
};


const dirtyData = {
  setShowAlert(state) {
    state.showAlert = true;

    if (state.alertTimer !== null) {
      /* Clear timer */
      clearTimeout(state.alertTimer);
      state.alertTimer = null;
    }

    if (state.alertType === 'success') {
      state.alertTimer = setTimeout(() => {
        state.showAlert = false;
      }, 5000);
    }
  },
  removeShowAlert(state) {
    if (state.alertTimer !== null) {
      clearTimeout(state.alertTimer);
      state.alertTimer = null;
    }

    state.showAlert = false;
  },
  setIsDirty(state, isDirty) {
    state.isDirty = isDirty;
  },
};

const mutations = {
  setTempState(state, payload) {
    const { path, value } = payload;
    _set(state, path, value);
  },
  ...calendar,
  ...dirtyData,
};

export default mutations;
